import React, { useState } from 'react';
import { flyersandbrochures } from '../data/flyersandbrochures';


const Flyers = () => {
  const [search, setSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [location, setLocation] = useState('All');

  const handleClearAll = () => {
    setSearch('');
    setLocation('All');
    setShowDropdown(false);
  };

  // Get unique locations for dropdown
  const locationOptions = ['All', ...Array.from(new Set(flyersandbrochures.map(f => f.location)))];

  // Filter logic for flyers
  let filteredFlyers = [...flyersandbrochures].filter(
    (flyer) => flyer.accountstatus === true || flyer.accountstatus === 'A'
  );
  if (location !== 'All') {
    filteredFlyers = filteredFlyers.filter(flyer => flyer.location === location);
  }
  if (search.trim() !== '') {
    filteredFlyers = filteredFlyers.filter(flyer =>
      flyer.businessname.toLowerCase().includes(search.trim().toLowerCase())
    );
  }
  filteredFlyers.sort((a, b) => {
    const orderA = Number(a.listorder);
    const orderB = Number(b.listorder);
    const safeOrderA = Number.isNaN(orderA) ? Number.MAX_SAFE_INTEGER : orderA;
    const safeOrderB = Number.isNaN(orderB) ? Number.MAX_SAFE_INTEGER : orderB;
    return safeOrderA - safeOrderB;
  });

  return (
    <div style={{ paddingLeft: 10 }}>
      {/* Header */}
      <header style={{ background: '#e8f5e9', color: '#388e3c', padding: '0.25rem', textAlign: 'center', borderRadius: 8, marginBottom: 2 }}>
        <h1 style={{ margin: 0, fontSize: '1.0rem', fontWeight: 700 }}>Flyers : Weekly deals & offers</h1>
      </header>
      <div style={{ marginBottom: '0.4rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <div>
          <label htmlFor="location-select" style={{ fontWeight: 500, marginRight: 8 }}>Location:</label>
          <select
            id="location-select"
            value={location}
            onChange={e => setLocation(e.target.value)}
            style={{ padding: '0.18rem 0.3rem', borderRadius: 4, border: '1px solid #c5e1a5', fontSize: '0.89rem', minWidth: 60, height: '1.4rem', width: 100 }}
          >
            {locationOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="flyer-search" style={{ fontWeight: 500, marginRight: 8 }}>Search:</label>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                id="flyer-search"
                type="text"
                value={search}
                onChange={e => setSearch(e.target.value)}
                onFocus={() => setShowDropdown(true)}
                onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
                placeholder="Type business name..."
                style={{ padding: '0.18rem 0.3rem', borderRadius: 4, border: '1px solid #c5e1a5', fontSize: '0.75rem', minWidth: 30, height: '1.2rem', width: 100 }}
              />
            </div>
            {showDropdown && (
              <div style={{ position: 'absolute', background: '#fff', border: '1px solid #c5e1a5', borderRadius: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginTop: 2, zIndex: 10, minWidth: 100 }}>
                {flyersandbrochures.map(flyer => (
                  <div
                    key={flyer.id}
                    style={{ padding: '0.2rem 0.5rem', cursor: 'pointer', fontSize: '0.85rem' }}
                    onMouseDown={() => { setSearch(flyer.businessname); setShowDropdown(false); }}
                  >
                    {flyer.title}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div>
          <button
            type="button"
            onClick={handleClearAll}
            style={{
              padding: '0.22rem 0.7rem',
              borderRadius: 4,
              border: '1px solid #388e3c',
              background: '#388e3c',
              color: '#fff',
              fontSize: '0.76rem',
              fontWeight: 600,
              cursor: 'pointer',
              height: '1.45rem'
            }}
          >
            Clear All
          </button>
        </div>
      </div>
      <p style={{ marginBottom: 0.3, marginTop: 0, fontSize: '0.95rem' }}>Records listed: {filteredFlyers.length}</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.7rem' }}>
        {filteredFlyers.map((flyer, idx) => (
          <a
            key={flyer.id}
            href={flyer.imagepath}
            target="_blank"
            rel="noopener noreferrer"
            style={{ border: '1px solid #c5e1a5', borderRadius: '8px', padding: '1rem', width: '420px', background: '#f9fbe7', display: 'flex', alignItems: 'center', gap: '1rem', minHeight: 240, overflow: 'hidden', position: 'relative', textDecoration: 'none', color: 'inherit' }}
          >
            <img
              src={flyer.imagepath}
              alt={flyer.title}
              style={{ width: 170, height: 220, objectFit: 'contain', background: '#fff', borderRadius: 8, flexShrink: 0, border: '1px solid #dcedc8' }}
              onError={e => {
                e.target.onerror = null;
                e.target.src = '/images/flyersimages/placeholder.jpg';
              }}
            />
            <div style={{ flex: 1, overflowWrap: 'break-word', whiteSpace: 'normal', minWidth: 0 }}>
              <h3 style={{ margin: '0 0 0.3rem 0', color: '#388e3c', fontSize: '1rem', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{flyer.title}</h3>
              <div style={{ fontWeight: 'bold', fontSize: '1.08rem', marginBottom: 2, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{flyer.businessname}</div>
              <div style={{ color: '#757575', fontSize: '0.95rem', marginBottom: 2, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{flyer.location}</div>
              <div style={{ margin: '0.3rem 0', fontSize: '0.95rem', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{flyer.description}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
export default Flyers;
